export default [{ value: 'EST', label: 'EST (Eastern Standard Time)' },
{ value: 'PST', label: 'PST (Pacific Standard Time)' },
{ value: 'CST', label: 'CST (Central Standard Time)' },
{ value: 'MST', label: 'MST (Mountain Standard Time)' },
{ value: 'AST', label: 'AST (Atlantic Standard Time)' },
{ value: 'HST', label: 'HST (Hawaii Standard Time)' },
{ value: 'AZ', label: 'AZ (Mountain Standard Time)' }]